<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap xs12 sm6>
      <v-flex >
        <v-card class="elevation-1">
          <v-card-title>
            <v-switch label="Crear" v-model="canCreate" ></v-switch>
          </v-card-title>
          <v-divider></v-divider>
        </v-card>

      </v-flex>
      <v-flex>
        <v-card class="elevation-1">
          <v-card-title>
            <v-switch label="Lectura" v-model="canRead" ></v-switch>
          </v-card-title>
          <v-divider></v-divider>
          <v-radio-group v-if="canRead && permisos.read" class="ml-2" v-model="permisos.read.relation">
            <v-radio
              v-for="n in ['ALL','GROUP','OWNER']"
              :key="n"
              :label="`${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
          <v-progress-linear v-show="actualizando == 'READ'"
            :indeterminate="true" color="green" height="2" class="my-0">
          </v-progress-linear>
        </v-card>
      </v-flex>

      <v-flex>
        <v-card class="elevation-1">
          <v-card-title>
            <v-switch label="Actualizar" v-model="canUpdate" ></v-switch>
          </v-card-title>
          <v-divider></v-divider>
          <v-radio-group v-if="canUpdate && permisos.update" class="ml-2" v-model="permisos.update.relation">
            <v-radio
              v-for="n in ['ALL','GROUP','OWNER']"
              :key="n"
              :label="`${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
          <v-progress-linear v-show="actualizando == 'UPDATE'"
            :indeterminate="true" color="green" height="2" class="my-0">
          </v-progress-linear>
        </v-card>
      </v-flex>

      <v-flex>
        <v-card class="elevation-1">
          <v-card-title>
            <v-switch label="Eliminar" v-model="canDelete" ></v-switch>
          </v-card-title>
          <v-divider></v-divider>
          <v-radio-group v-if="canDelete && permisos.delete" class="ml-2" v-model="permisos.delete.relation">
            <v-radio
              v-for="n in ['ALL','GROUP','OWNER']"
              :key="n"
              :label="`${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
          <v-progress-linear v-show="actualizando == 'DELETE'"
            :indeterminate="true" color="green" height="2" class="my-0">
          </v-progress-linear>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
import Permisos from '../../services/permisos'
import * as _ from 'lodash'

export default {
  name: 'ModelsLista',
  props: ['model','group'],
  data () {
    return {
      registros: null,
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      canCreate: null,
      canUpdate: null,
      canRead: null,
      canDelete: null,
      permisos: {
        read: null,
        create: null,
        update: null,
        delete: null
      },
      actualizando: ''
    }
  },
  methods: {
    parsePermisos() {
      if (this.registros.length > 0) {
        this.permisos.create = _.find(this.registros, ['action', 'CREATE']);
        this.permisos.read = _.find(this.registros, ['action', 'READ']);
        this.permisos.update = _.find(this.registros, ['action', 'UPDATE']);
        this.permisos.delete = _.find(this.registros, ['action', 'DELETE']);
        //Valores boolean
        this.canCreate = this.permisos.create ? true : false;
        this.canRead = this.permisos.read ? true : false;
        this.canUpdate = this.permisos.update ? true : false;
        this.canDelete = this.permisos.delete ? true : false;
      }
    },
    async setPermiso(opcion) {
      let res
      switch (opcion) {
        case 'CREATE':
          if (this.canCreate && !this.permisos.create) { //Dar de alta el permiso de crear
              let p = {
                action: 'CREATE',
                model: this.model,
                relation: 'ALL',
                group: this.group
              }
              res = await Permisos.save(p)
              this.permisos.create = res
          } else if (!this.canCreate && this.permisos.create) {
            res = await Permisos.delete(this.permisos.create.id)
            this.permisos.create = null
          }
        break
        case 'READ':
        if (this.canRead && !this.permisos.read) { //Dar de alta el permiso de lectura
            let p = {
              action: 'READ',
              model: this.model,
              relation: 'OWNER',
              group: this.group
            }
            res = await Permisos.save(p)
            this.permisos.read = res
        } else if(!this.canRead && this.permisos.read) { //Eliminar el permiso
          res = await Permisos.delete(this.permisos.read.id)
          this.permisos.read = null
        }
        break
        case 'UPDATE':
        if (this.canUpdate && !this.permisos.update) { //Dar de alta el permiso de lectura
            let p = {
              action: 'UPDATE',
              model: this.model,
              relation: 'OWNER',
              group: this.group
            }
            res = await Permisos.save(p)
            this.permisos.update = res
        } else if(!this.canUpdate && this.permisos.update) { //Eliminar el permiso
          res = await Permisos.delete(this.permisos.update.id)
          this.permisos.update = null
        }
        break
        case 'DELETE':
        if (this.canDelete && !this.permisos.delete) { //Dar de alta el permiso de lectura
            let p = {
              action: 'DELETE',
              model: this.model,
              relation: 'OWNER',
              group: this.group
            }
            res = await Permisos.save(p)
            this.permisos.delete = res
        } else if(!this.canDelete && this.permisos.delete) { //Eliminar el permiso
          res = await Permisos.delete(this.permisos.delete.id)
          this.permisos.delete = null
        }
        break
      }
    },
    async updatePermiso(opcion) {
      this.actualizando = opcion
      let res
      switch (opcion) {
        case 'READ':
          res = Permisos.update(this.permisos.read)
        break;
        case 'UPDATE':
          res = Permisos.update(this.permisos.update)
        break;
        case 'DELETE':
          res = Permisos.update(this.permisos.delete)
        break;
        default: break;
      }
      setTimeout(() => {
        this.actualizando = ''
      },800)
    }
  },
  watch: {
    canCreate: function(){
      this.setPermiso('CREATE')
    },
    canRead: function(){
      this.setPermiso('READ')
    },
    canUpdate: function(){
      this.setPermiso('UPDATE')
    },
    canDelete: function(){
      this.setPermiso('DELETE')
    },
    'permisos.read.relation': function(newV, oldV){
      if (oldV && newV) {
        this.updatePermiso('READ')
      }
    },
    'permisos.update.relation': function(newV, oldV){
      if (oldV && newV) {
        this.updatePermiso('UPDATE')
      }
    },
    'permisos.delete.relation': function(newV, oldV){
      if (oldV && newV) {
        this.updatePermiso('DELETE')
      }
    }
  },
  async beforeMount() {
    if (this.model && this.group) {
      let res = await Permisos.list({ model: this.model, group: this.group, populate: 'usuarioCreacion' })
      this.registros = res
      await this.parsePermisos()
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/permisos/PermisoComponent.vue